import type { VFXPrimitive } from '../VFXEffectRegistry';

/**
 * A primitive's offsetX is authored right-facing; mirror it with the cast
 * direction. Shared by ShapeSpawner's plain and scattered spawns (plan 21 B22:
 * the scattered path used to add it unmirrored).
 */
export function facingOffsetX(prim: Pick<VFXPrimitive, 'offsetX'>, overrides?: { flipX?: boolean }): number {
  return overrides?.flipX === true ? -(prim.offsetX || 0) : (prim.offsetX || 0);
}
